import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { PlusIcon, MinusIcon } from 'lucide-react';
export function FAQSection() {
  const faqs = [{
    q: '¿Funciona si tengo más de 50 años?',
    a: '¡Absolutamente! Nuestros resultados más impresionantes son de mujeres de 45-55 años.'
  }, {
    q: '¿Necesito ingredientes especiales o costosos?',
    a: 'No. La base del protocolo se arma con ingredientes de supermercado: huevos, carnes/pescado accesibles, verduras de estación, legumbres, arroz/quinoa según fase, yogur natural y semillas. Además, incluimos una Guía de Compras Argentina (versión económica + sustituciones) para que lo adaptes a tu presupuesto.'
  }, {
    q: '¿Tengo que hacer ejercicio extremo?',
    a: 'Solo 15-25 minutos de ejercicios restaurativos. Nada de gym ni equipos costosos.'
  }, {
    q: '¿Qué pasa si no veo resultados?',
    a: 'Garantía de 30 días. Si H.E.R. no es para vos, te devolvemos el 100% de tu dinero.'
  }, {
    q: '¿Funciona si estoy en menopausia?',
    a: 'Especialmente efectivo durante pre/menopausia. Está diseñado para esta etapa.'
  }, {
    q: '¿Es seguro si tengo condiciones médicas?',
    a: 'Es un protocolo natural, pero siempre consulta con tu médico primero.'
  }];
  return <section className="bg-gradient-hero py-12 md:py-16 px-4 md:px-8" style={{
    paddingTop: "0px"
  }} data-id="element-82" data-mp="25hf9hi1wx5xd">
      <div className="max-w-3xl mx-auto space-y-12" data-id="element-83" data-mp="2fdqncch5i3tx">
        {/* Header */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center space-y-4" data-id="element-84" data-mp="2ffv0ll0xwf6v">
          <h2 className="text-4xl md:text-5xl font-display font-black" data-id="element-85" data-mp="2occakkxki711">
            Preguntas <span className="text-gradient-gold" data-id="element-86" data-mp="2jg54ms568vj3">Frecuentes</span>
          </h2>
        </motion.div>

        {/* Accordions */}
        <div className="space-y-4" data-id="element-87" data-mp="p1cbczrrggub">
          {faqs.map((faq, i) => <FAQItem key={i} faq={faq} index={i} data-id="element-88" data-mp="p2vsesl8qvx5" data-mpi={i} />)}
        </div>
      </div>
    </section>;
}
function FAQItem({
  faq,
  index
}: {
  faq: {
    q: string;
    a: string;
  };
  index: number;
}) {
  const [isOpen, setIsOpen] = useState(false);
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true
  }} transition={{
    duration: 0.5,
    delay: index * 0.1
  }} className="card-premium overflow-hidden" data-id="element-89" data-mp="2z2004wwmkutb">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full flex items-center justify-between p-5 md:p-6 text-left hover:bg-white/[0.02] transition-colors" data-id="element-90" data-mp="381n33n5068oh">
        <span className="font-body font-semibold text-base md:text-lg text-foreground flex items-start md:items-center gap-3 leading-snug" data-id="element-91" data-mp="3hshsh0djpoe5">
          <span className="text-xl mt-0.5 md:mt-0" data-id="element-92" data-mp="3mq16bz6bzz5k">❓</span> {faq.q}
        </span>
        <span className="text-secondary flex-shrink-0 ml-4" data-id="element-93" data-mp="3qtz34386oxvg">
          {isOpen ? <MinusIcon className="w-6 h-6" data-id="element-94" data-mp="3vrr5xsada4ef" /> : <PlusIcon className="w-6 h-6" data-id="element-95" data-mp="3vt267i4lsu0s" />}
        </span>
      </button>

      <AnimatePresence data-id="element-96" data-mp="1k56v34duchmx">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3
      }} data-id="element-97" data-mp="1k5gpd45x5ayf">
            <div className="px-5 md:px-6 pb-6 pt-2 text-foreground/80 font-body text-[15px] md:text-base font-medium flex items-start gap-3 border-t border-border/50 mt-2 leading-relaxed" data-id="element-98" data-mp="164w481cj731r">
              <span className="text-xl mt-1" data-id="element-99" data-mp="22wzmwvh6bwt2">✅</span>
              <p className="pt-1" data-id="element-100" data-mp="1yuuwe5m0vgan">{faq.a}</p>
            </div>
          </motion.div>}
      </AnimatePresence>
    </motion.div>;
}